import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/planning_/$planId/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
